var cbtUtil = require("./cbtUtil");
var debounce = require("lodash/debounce");

function sortFilterEvent() {
    $(document).on("change", "#sort-order-clp", function () {
        var dataLayer = $("#sort-order-clp option:selected").data("sort-option-cbt");
        cbtUtil.dataPush(dataLayer);
    });
}

function filterClicks() {
    $(".container").on("click", ".refinements li button", function() {
        var isSelectedFilter = $(this).parent().find("input").is(":checked");

        if (isSelectedFilter) {
            return;
        }

        var dataLayer = $(this).data("filter-cbt");

        if (dataLayer) {
            cbtUtil.dataPush(dataLayer);
        }
    });
}

function cbtSearchResult() {
    $.each($(".cbt-search-products"), function() {
        var searchResultsData = $(this).data("search-results");
        cbtUtil.dataPush(searchResultsData);
    });
}

/**
 * @description event for trigger dataleyr push on scroll of CLP
 */
function cbtCLPProductListViewGrowth() {
    var $searchResults = $(".search-results");

    if ($searchResults.length) {
        var $clpData = $(".clp-cbt-data");
        var clpDataLayer = cbtUtil.parseJSON($clpData.data("clp-cbt"));
        $(window).on("scroll", function() {
            var $productTiles = $(".product-tile").not(".cbt-listed");
            if ($productTiles.length) {
                var debounceScroll = debounce(getCLPProductListGrowthDataLayer, 200);
                debounceScroll($productTiles, $clpData, clpDataLayer);
            }
        });
    }
}

/**
 * @description constructs datalayer for the product list in CLP
 * @param {jQuery} $productTiles - product tiles from CLP that can be pushed to datalayer
 * @param {jQuery} $clpData - element that contains datalayer information without products array
 * @param {Object} clpDataLayer - datalayer object without products array
 */
function getCLPProductListGrowthDataLayer($productTiles, $clpData, clpDataLayer) {
    var clpStartIndex = Number($clpData.data("clp-cbt-index"));
    var productsList = [];
    $productTiles.not(".cbt-listed").each(function(i, el) {
        var $element = $(el);
        var isInViewport = $element.isInViewport();
        if (isInViewport && !$element.hasClass("cbt-listed")) {
            $element.addClass("cbt-listed");
            var productCbtData = cbtUtil.parseJSON($element.find(".producttile-add-to-cart").data("cbt"));
            //The GTM attribute products from productCbtData only contains one product
            //But the array productsList can contain multiple products depending on the valid slides
            if (productCbtData && productCbtData.products) {
                productCbtData.products[0].position = clpStartIndex + Number($element.parents(".product-tile-order").data("value"));
                productsList.push(productCbtData.products[0]);
            }
        }
    });
    if (productsList.length && clpDataLayer) {
        clpDataLayer.products = productsList;
        cbtUtil.dataPush(clpDataLayer);
    }
}

window.addEventListener("load", function () {
    sortFilterEvent();
    filterClicks();
    cbtSearchResult();
    cbtCLPProductListViewGrowth();
});
